import parse from "url-parse";
import missingImageURL from "../images/missing.png";

export const getImageURL = (src, size = "440x440") => {
  const srcComponents = parse(src || missingImageURL, true);
  srcComponents.query.d = size;
  return srcComponents.toString();
};
